<template>
    <div class="main-cn">
        <div class="main-hd">
            <h4>{{title}}</h4>
        </div>
        <div class="main-bd mg20">
            <el-row class="addBtn" >
                <div>
                    <el-button style="float: left" @click="triggerCreate" type="primary" size="small">创建权限</el-button>
                    <el-form :model="search_form" ref="form" :rules="rules">
                        <el-form-item label="权限名称" prop="permission_name" :label-width="formLabelWidth">
                            <PermissionsSelect v-model="search_form.permission_name"
                                            @change="permissionHandleChange"></PermissionsSelect>
                            <el-button  :loading="submiting" type="primary" @click="getPermissions()">搜索</el-button>
                        </el-form-item>

                    </el-form>
                </div>
            </el-row>
            <el-dialog :title="dialogTitle" :visible.sync="showForm" :before-close="handleClose">
                <el-form :model="form" ref="form" :rules="rules">

                    <el-form-item label="权限名称" prop="name" :label-width="formLabelWidth">
                        <el-input v-model="form.name" placeholder="请输入权限名称"></el-input>
                    </el-form-item>

                    <el-form-item label="所属模块" prop="module" :label-width="formLabelWidth">
                        <el-select v-model="form.module" placeholder="请选择权限所属模块">
                            <el-option v-for="module in modules" :key="module.key" :label="module.name" :value="module.key"></el-option>
                        </el-select>
                    </el-form-item>

                    <el-form-item label="权限路由" prop="route" :label-width="formLabelWidth">
                        <el-input v-model="form.route" placeholder="请正确填写权限控制访问路由"></el-input>
                    </el-form-item>

                    <el-form-item label="备注" prop="memo" :label-width="formLabelWidth">
                        <el-input type="textarea" :rows="5" v-model="form.memo" auto-complete="off"></el-input>
                    </el-form-item>
                </el-form>
                <div slot="footer" class="dialog-footer">
                    <el-button @click="handleClose">取 消</el-button>
                    <el-button :loading="submiting" type="primary" @click="handleSave">确 定</el-button>
                </div>
            </el-dialog>

            <el-table :data="permissions" class="tabTopBorder" style="width: 100%" v-loading="loading">
                <el-table-column prop="id" label="ID"></el-table-column>
                <el-table-column prop="name" label="权限名称">
                    <template slot-scope="scope">
                        <div v-html="scope.row.name"></div>
                    </template>
                </el-table-column>
                <el-table-column prop="route" label="路由"></el-table-column>
                <el-table-column prop="module_name" label="所属模块"></el-table-column>
                <el-table-column prop="created_at" label="创建时间"></el-table-column>
                <el-table-column label="操作">
                    <template slot-scope="scope">
                        <el-button @click="triggerUpdate(scope.row)" type="text" size="small">编辑</el-button>
                        <el-button @click="handleDelete(scope.row)" type="text" size="small">删除</el-button>
                    </template>
                </el-table-column>
            </el-table>
            <el-row v-if="linkPage">
                <pagination :linkPage="linkPage"></pagination>
            </el-row>
        </div>
    </div>
</template>

<script>
    import Pagination from "~/widgets/Pagination.vue";
    import UserService from "~/services/user";
    import {PermissionModel, PermissionService} from "~/services/Permission";
    import PermissionsSelect from "~/widgets/PermissionsSelect.vue";


    export default {
        components: {
            PermissionsSelect,
            Pagination
        },
        data() {
            return {
                title: "权限管理",
                dialogTitle: "创建权限",
                searcherModel: {
                    text: "",
                    status: ""
                },
                formLabelWidth: "120px",
                form: {
                    name: '',
                    module: '',
                    route: '',
                    memo: ''
                },
                search_form:{
                    permission_name: '',
                },
                modules: [], // 模块列表
                showForm: false, // 是否显示表单窗口
                permissions: [], // 权限列表数据
                loading: true, // 数据加载
                submiting: false,
                // 分页信息
                linkPage: null,
                rules: {
                    name: [
                        {
                            required: true,
                            message: "请输入权限名称"
                        },
                        {
                            type: "string",
                            max: 255,
                            message: "长度不能超过255个字符"
                        }
                    ],
                    route: [
                        {
                            required: true,
                            message: "请输入权限路由"
                        },
                        {
                            type: "string",
                            max: 255,
                            message: "长度不能超过255个字符"
                        }
                    ],
                    module: [
                        {
                            required: true,
                            message: "请正确选择模块"
                        }
                    ]
                }
            };
        },
//permissionHandleChange

        // 监听路由参数更新执行分页请求
        beforeRouteUpdate: function (to, from, next) {
            this.getPermissions({
                page: to.query["page"],
                perPage: to.query["perPage"]
            });
        },

        created: function () {
            document.title = this.title;
            this.getModules();
            if (this.permissions.length <= 0) {
                this.getPermissions();
            }
        },

        methods: {
            permissionHandleChange(object) {
                this.search_form.permission_name = object.value;
            },
            // 处理关闭对话窗口事件
            handleClose() {
                this.$confirm("陛下你还没有保存内容，确认要关闭窗口？")
                    .then(_ => {
                        this.closeForm();
                    })
                    .catch(_ => {
                    });
            },

            /**
             * 获取模块列表
             */
            getModules() {
                PermissionService.getModules().then(res => {
                    if (res && res.code == 0) {
                        this.modules = res.data;
                    }
                }).catch(err => {
                    console.error(err);
                });
            },

            /**
             * 得到权限列表
             * @param params
             */
            getPermissions(params = {}) {
                this.loading = true;
                PermissionService.getList({
                    name:this.search_form.permission_name,
                    page: params.page,
                    perPage: params.perPage
                }).then(res => {
                    this.permissions = res.data;
                    if (res._meta) {
                        this.linkPage = res._meta;
                    }
                    this.loading = false;
                });
            },

            /**
             * 关闭表单
             */
            closeForm() {
                this.showForm = false;

                // 强制清空表单
                this.$refs["form"].resetFields();
            },

            /**
             * 处理保存
             */
            handleSave() {

                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.submiting = true;
                        if (parseInt(this.form.id) == 0) {
                            // 处理创建逻辑
                            this.handleCreate(this.form);
                        } else {
                            // 处理更新逻辑
                            this.handleUpdate(this.form);
                        }
                    }
                });
            },

            /**
             * 处理创建权限逻辑
             * @param form
             */
            handleCreate(form) {

                if (parseInt(form) > 0) {
                    return;
                }

                PermissionService.create(this.form).then(res => {
                    if (res && res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "创建成功！"
                        });
                        // 强制清空表单
                        this.$refs["form"].resetFields();
                        this.closeForm();
                        this.submiting = false;
                        this.getPermissions(); // 重新加载列表
                    }
                }).catch(err => {
                    console.error(err);
                })

                this.submiting = false;
            },

            /**
             * 处理更新权限逻辑
             * @param form
             */
            handleUpdate(form) {
                if (parseInt(form.id) <= 0) {
                    return;
                }

                PermissionService.update(this.form).then(res => {
                    if (res && res.code == 0) {
                        this.$message({
                            type: "success",
                            message: "创建成功！"
                        });
                        this.closeForm();
                        this.submiting = false;
                        this.getPermissions(); // 重新加载列表
                    }
                }).catch(err => {
                    console.error(err);
                })

                this.submiting = false;
            },

            triggerCreate() {
                this.showForm = true;
                this.form = PermissionModel;
                this.form.id = 0;
            },

            triggerUpdate(permission) {
                if (!permission) {
                    return;
                }

                this.dialogTitle = "编辑权限";
                this.showForm = true; // 打开编辑窗口
                this.form.id = permission.id;
                this.form.name = permission.name;
                this.form.route = permission.route;
                this.form.module = permission.module;
                this.form.memo = permission.memo;
            },

            // 处理删除权限
            handleDelete(permission) {
                if (!permission || permission.id <= 0) {
                    return;
                }

                this.$confirm("确认要删除该权限？")
                    .then(_ => {
                        PermissionService.delete(permission.id).then(res => {
                            if (res && res.code == 0) {
                                this.$message({
                                    type: "success",
                                    message: "删除成功！"
                                });
                                this.getPermissions(); // 重新加载列表
                            }
                        }).catch(err => {
                            console.error(err);
                        })
                        return;
                    }).catch(_ => {
                    return;
                });
            }

        }
    };
</script>


// WEBPACK FOOTER //
// src/views/permission/index.vue